<template>
  <v-simple-table class="mb-10">
    <template v-slot:default>
      <tbody>
        <tr v-for="item in details" :key="item.name">
          <td>
            <b>{{ item.name }}</b>
          </td>
          <td
            v-if="
              item.name == 'Moderator Feedback' && $store.state.role == 'ao'
            "
          >
            <v-textarea
              :readonly="$store.state.role == 'centre'"
              v-model="moderatorFeedback"
            ></v-textarea>
          </td>
          <td v-if="item.name == 'Date Moderated' && $store.state.role == 'ao'">
            <v-menu
              ref="menu"
              :disabled="$store.state.role == 'centre'"
              v-model="menu"
              :close-on-content-click="false"
              :return-value.sync="date"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="date"
                  label="Moderation Date"
                  prepend-icon="event"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="date"
                no-title
                scrollable
                @input="
                  $refs.menu[0].save(date);
                  onAddModerationDate();
                "
              >
                <v-spacer></v-spacer>
              </v-date-picker>
            </v-menu>
          </td>
          <td v-else>{{ item.value }}</td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
export default {
  props: {
    item: Object, // unit object passed from UnitDetails component
  },
  mounted: function () {
    this.section = this.$route.params.section;
    this.id = this.$route.query.id;

    this.getCertification();
  },
  data() {
    return {
      date: null,
      menu: false,
      moderatorFeedback: "",
      details: [],
      mapper: [
        {
          name: "Centre Name",
          mapTo: "centre",
        },
        {
          name: "Learner Name",
          mapTo: "learner",
        },
        {
          name: "Request Date",
          mapTo: "createdAt",
        },
        {
          name: "Total Credits Points",
          mapTo: "totalCredits",
        },

        {
          name: "Status",
          mapTo: "status",
        },
        {
          name: "Moderator Name",
          mapTo: "moderatorName",
        },
        {
          name: "Moderator Feedback",
          mapTo: "moderatorFeedback",
        },
        {
          name: "Date Moderated",
          mapTo: "dateModerated",
        },
        {
          name: "Moderation Requested",
          mapTo: "moderationRequested",
        },
      ],
    };
  },
  watch: {
    moderatorFeedback: async function (newValue) {
      try {
        const response = await fetch(
          `${process.env.VUE_APP_ROOT_API}/certifications/${this.$route.query.id}/moderatorFeedback`,
          {
            method: "PATCH",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.$store.state.jwt}`,
            },
            body: JSON.stringify({
              moderatorFeedback: newValue,
            }),
          }
        );

        const data = await response.json();
        console.log(data);
      } catch (error) {
        console.log(error);
      }
    },
  },
  methods: {
    getCertification: function () {
      // execute for new unit summary
      if (this.item) {
        this.writeToTable(this.item);
        return;
      }

      // execute for existing unit summary
      fetch(`${process.env.VUE_APP_ROOT_API}/certifications/${this.id}`, {
        headers: {
          Authorization: `Bearer ${this.$store.state.jwt}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          this.$emit("certificationStatus", {
            status: data.certification.status,
            assessments: data.certification.assessments,
            isInvoiceRisen: data.certification.isInvoiceRisen,
            qualification: {
              code: data.certification.qualificationCode,
              name: data.certification.qualificationName,
            },
          });

          this.writeToTable(data.certification);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    writeToTable: function (item) {
      // to arrange the details to summary table in the desirable order
      this.mapper.map((key) => {
        Object.keys(item).map((i) => {
          if (key.mapTo == i) {
            let value;

            if (key.mapTo == "centre") {
              value = item[i].name;
            } else if (key.mapTo == "learner") {
              value = `${item[i].firstName} ${item[i].middleName || ""} ${
                item[i].lastName
              }`;
            } else if (key.mapTo == "moderatorFeedback") {
              if (this.$store.state.role == "centre") {
                value = item[i] || "TBD";
              } else {
                if (item[i]) {
                  this.moderatorFeedback = item[i];
                }
              }
            } else if (key.mapTo == "dateModerated") {
              if (this.$store.state.role == "centre") {
                value = item[i] || "TBD";
              } else {
                if (item[i]) {
                  this.date = item[i];
                }
              }
            } else if (key.mapTo == "status") {
              if (item[i] == "moderation" && this.$store.state.role == "ao") {
                value = "Waiting for centre to upload assessment";
              } else if (
                item[i] == "moderation" &&
                this.$store.state.role == "centre"
              ) {
                value = "Assessment upload required";
              } else if (
                item[i] == "submitted" &&
                this.$store.state.role == "ao"
              ) {
                value = "Centre uploaded assessments";
              } else if (
                item[i] == "submitted" &&
                this.$store.state.role == "centre"
              ) {
                value = "Waiting for moderation";
              } else {
                value = item[i];
              }
            } else if (key.mapTo == "moderationRequested") {
              const requestedUnit = [];
              if (item[i]) {
                for (let j = 0; j < item[i].length; j++) {
                  requestedUnit.push(item[i][j].unit.code);
                }
              }

              value = requestedUnit.join(", ");
            } else if (key.mapTo == "dateModerated") {
              value = "Add moderation date";
            } else {
              value = item[i];
            }

            this.details.push({ name: key.name, value });
          }
        });
      });
    },
    onAddModerationDate: async function () {
      try {
        const response = await fetch(
          `${process.env.VUE_APP_ROOT_API}/certifications/${this.$route.query.id}/moderationDate`,
          {
            method: "PATCH",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.$store.state.jwt}`,
            },
            body: JSON.stringify({
              dateModerated: this.date,
            }),
          }
        );

        const data = await response.json();
        console.log(data);
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style scoped>
</style>